import { render, staticRenderFns } from "./erpRecharge.vue?vue&type=template&id=edc8ff0c&scoped=true&"
import script from "./erpRecharge.vue?vue&type=script&lang=js&"
export * from "./erpRecharge.vue?vue&type=script&lang=js&"
import style0 from "./erpRecharge.vue?vue&type=style&index=0&id=edc8ff0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc8ff0c",
  null
  
)

export default component.exports